module.exports = __webpack_public_path__ + "static/fixonsite-2fe097f2a017adb9d0317c01f6a85a4a.jpg";